export enum BRANCH_PROFILE_ASSET {
  COVER_IMAGE = 'coverImage',
  AVATAR_IMAGE = 'avatarImage',
}
